import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import homeFill from '@iconify/icons-eva/home-fill';
import lockFill from '@iconify/icons-eva/lock-fill';
import personFill from '@iconify/icons-eva/person-fill';
import settings2Fill from '@iconify/icons-eva/settings-2-fill';
import { Link as RouterLink } from 'react-router-dom';
// material
import { alpha } from '@mui/material/styles';
import { Button, Box, Divider, MenuItem, Typography, Avatar, IconButton } from '@mui/material';
// components
import MenuPopover from '../../components/MenuPopover';
//
import account from '../../_mocks_/account';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from 'src/store/reducers/userInfo';
import ChangePwdDialog from 'src/components/dialogs/ChangePwdDialog';
import ChangeInfoDialog from 'src/components/dialogs/ChangeInfoDialog';
import { asyncRequest } from 'src/services/network';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: '修改信息',
    icon: homeFill,
    linkTo: '/my',
    dialogType: 'info',
  },
  {
    label: '修改密码',
    icon: lockFill,
    linkTo: '/pwd',
    dialogType: 'pwd',
  },
  // {
  //   label: '信息',
  //   icon: personFill,
  //   linkTo: '#'
  // },
  // {
  //   label: '设置',
  //   icon: settings2Fill,
  //   linkTo: '#'
  // }
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const { username, } = useSelector(state => state.userInfo.userInfo);
  const dispatch = useDispatch();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const [dialogType, setDialogType] = useState('');

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {

    const { data } = await asyncRequest({
      method: 'get',
      path: "/system/admin/logout",
      complete() {
        dispatch(logout());
      }
    });
    
  }

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
            }
          })
        }}
      >
        <Avatar src={account.photoURL} alt="photoURL" />
      </IconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
            {username}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {/* {account.email} */}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            // to={option.linkTo}
            // component={RouterLink}
            // onClick={handleClose}
            onClick={() => {
              setDialogType(option.dialogType)
              handleClose();
            }}
            sx={{ typography: 'body2', py: 1, px: 2.5 }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24
              }}
            />

            {option.label}
          </MenuItem>
        ))}

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button fullWidth color="inherit" variant="outlined" onClick={handleLogout}>
            退出登录
          </Button>
        </Box>
      </MenuPopover>

      <ChangePwdDialog 
        open={dialogType === 'pwd'}
        onClose={() => setDialogType('')}
      />

      <ChangeInfoDialog 
        open={dialogType === 'info'}
        onClose={() => setDialogType('')}
      />


    </>
  );
}
